import { isExpired } from "react-jwt";
import { useCallback, useEffect, useRef, useState } from "react";

//export const serverurl = 'https://localhost:8000/app/';
//export const serverurl = 'http://192.168.1.142:8000/app/';
//export const serverurl =  'https://chehamohamed.alwaysdata.net/app/'
export const serverurl =  'https://djamnazi.alwaysdata.net/app/';


function JsonParse(response)
{
   try
   {
      return response.json();
   }
   catch(error)
   { 
      console.log(error);return {result:false,errors:["Erreur reseaux"]};
   }
} 

function ApiFetch(methode='post',target="",data={})
{
    let hearders = {'Content-Type':'application/json','Accept':'*/*'};
    const token = sessionStorage.getItem('accesstoken');
    if(!!token && !isExpired(token))
    {
      hearders = {
        'Content-Type':'application/json',
        'Accept':'*/*',
        'Authorization': `Bearer ${token}`
      };
    }
      
    switch(methode)
    {
      case 'post':
        return fetch(serverurl+target, {
          method: 'post',
          headers: hearders,
          credentials: 'include',
          body: JSON.stringify(data)}).then((response)=>{return JsonParse(response)});
      case 'get':
        return fetch(serverurl+target,{
          method: 'get',
          credentials: 'include',
          headers: hearders
        }).then((response)=>{return JsonParse(response)});
      case 'put':
        return fetch(serverurl+target,{
          method: 'put',
          headers: hearders,
          credentials: 'include',
          body: JSON.stringify(data)}).then((response)=>{return JsonParse(response)});
      case 'delete':
        return fetch(serverurl+target,{
          method: 'delete',
          credentials: 'include',
          headers: hearders,
          body: JSON.stringify(data)}).then((response)=>{return JsonParse(response)});
      default:
        return
    }
}


export function useFetch()
{
  const [error,setError] = useState("");
  useEffect(()=>{
  },[error]);

  const LogOut = useCallback(async (UserState,setUserState)=>{
      //setUserState({...UserState,auth:false,is_staff:false,labelname:"Espace Client"});
      const refreshtoken = sessionStorage.getItem('refreshtoken');
      return ApiFetch('post', 'user/logout/',{'refresh_token':refreshtoken}).finally(()=>{
        setUserState({...UserState,auth:false,is_staff:false,labelname:"Espace Client"});
        sessionStorage.removeItem('accesstoken');
        sessionStorage.removeItem('refreshtoken');
      });
  },[])

  const RefreshToken = useCallback(async (refreshtoken,UserState,setUserState)=>{
    return ApiFetch('post','user/login/refresh/',{refresh:refreshtoken}).then((token)=>{
        if(!!token.access)
        {
            sessionStorage.setItem('accesstoken',token.access);
            sessionStorage.setItem('refreshtoken',token.refresh);
        }
        else
        {LogOut(UserState,setUserState);} 
      }).catch((error)=>console.log(error));
  },[])

  const Authenticate = useCallback((UserState,setUserState) => {

    const token = sessionStorage.getItem('accesstoken');
    if(!!token)
    {
        if(!isExpired(token))
        {
            let rik_id = sessionStorage.getItem('rikinaze_id');
            if(rik_id===undefined || rik_id === null)
               rik_id = 'undefined';
            ApiFetch('get',`user/authentication/${rik_id}/`).then((result)=>{
                if(!result.result)
                {
                  LogOut(UserState,setUserState);
                }
                else
                {
                  if(!UserState.auth)
                    {GetAppUser(UserState,setUserState);}
                }
                
            }).catch(()=>{});
        }
        else if(isExpired(token))
        {
            const refreshtoken = sessionStorage.getItem('refreshtoken');
            if(!!refreshtoken && !isExpired(refreshtoken))
            {RefreshToken(refreshtoken,UserState,setUserState);}
            else
            {LogOut(UserState,setUserState);}
        }
    }
    //else
    //{LogOut(UserState,setUserState);}
  }, []);

  const PostData = useCallback(async (data,target='user')=>
    {
        return ApiFetch('post',target,data);
  },[]);

  const PutData = useCallback(async (data,target='user')=>{
       return ApiFetch('put',target, data);
  },[]);

  const DeleteData = useCallback(async (data,target='user')=>{
    return ApiFetch('delete',target, data);
  },[]);

  const PostFormData = useCallback(async (FormData,target)=>
    {
        let hearders = {'Accept':'*/*'};
        const token = sessionStorage.getItem('accesstoken');
        if(!!token && !isExpired(token))
        {
          hearders = {
            'Accept':'*/*',
            'Authorization': `Bearer ${token}`
          };
        }
        return fetch(serverurl+target,{
          method:'post',
          headers:hearders,
          body: FormData
        }).then((response)=>{return JsonParse(response)});
  },[])

  const PutFormData = useCallback(async (FormData,target)=>
    {
        let hearders = {'Accept':'*/*'};
        const token = sessionStorage.getItem('accesstoken');
        console.log(isExpired(token));
        if(!!token && !isExpired(token))
        {
          hearders = {
            'Accept':'*/*',
            'Authorization': `Bearer ${token}`
          };
        }
        return fetch(serverurl+target,{
          method:'put',
          headers:hearders,
          body: FormData
        }).then((response)=>{return JsonParse(response)});
  },[])

  const GetData = useCallback(async (url)=>
  {
      return ApiFetch('get',url);
  },[]);

  const GetAppUser = useCallback(async (UserState,setUserState)=>{
      let _panier = {articles:[]};
      UserState.panier.articles.forEach((item) => {
          console.log(item);
          _panier.articles.push({article:{id:item.article.id},quantity:item.quantity,location_dates:item.location_dates});
      });

      PostData(_panier,'user/login/profile/').then((res)=>
      {
         console.log(res);
          if(!!res.user)
            setUserState({...res.user});
          else
            setError("Erreur de connexion");;
      }).catch((error)=>{setError("Erreur de connexion");});
  },[])

  const LoginAuth = useCallback(async (loginData,UserState,setUserState) => {
    if(!UserState.auth)
    {
        PostData(loginData,'user/login/').then((result)=>
        {
           if(result.result)
           {
              const token = result.tokens;
              sessionStorage.setItem('accesstoken',token.access);
              sessionStorage.setItem('refreshtoken',token.refresh);
              GetAppUser(UserState,setUserState);
              setError(0);
           }
           else
           {setError(result.error);}
           return result.error;
      }).catch((error)=>{setError("Erreur de connexion"); return "Erreur de connexion";});
    }
}, []);


  return ({'PostFormData':PostFormData,
    'PutFormData': PutFormData,
    'PostData':PostData,
    'DeleteData':DeleteData,
    'PutData':PutData,
    'GetData':GetData,
    'Authenticate':Authenticate,
    'Login':LoginAuth,
    'LogOut':LogOut,
    'error':error
  });
}

export const FetchData=()=>{};
